import Metatags from '@components/common/Metatags';
import StoreLocatorMap from '@components/storelocator/StoreLocatorMap';
import { StoreLocatorActionTypes } from '@state/features/common.types';
import { currentStoreSelector } from '@state/features/storelocator.selectors';
import JsonLd from '@utils/JsonLd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import StoreBreadcrumb from '@components/storelocator/StoreBreadcrumb';
import StoreSummary from '@stone/components/storelocator/StoreSummary';
import { StorePageInnerSection, StorePageSection } from './StoreSections';
import { t } from 'i18next';
import StoreAddress from '@components/storelocator/StoreAddress';
import StoreServices from './StoreServices';
import StoresNearby from './StoresNearby';
const StorePage = (props) => {
    var _a;
    const { store, country, city } = useParams();
    const dispatch = useDispatch();
    useEffect(() => {
        if (store) {
            const slug = `${country}/${city}/${store}`;
            dispatch({ type: StoreLocatorActionTypes.FETCH_STORE_DETAILS, payload: slug });
        }
    }, []);
    const storedetail = useSelector(currentStoreSelector);
    if (!storedetail) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "store-page" },
        React.createElement(Metatags, { pageMetaTags: storedetail.pageMetaTags, meta: storedetail.meta }),
        React.createElement(JsonLd, { data: {
                '@context': 'https://schema.org',
                '@type': 'Store',
                image: storedetail.image && false ? [storedetail.image] : [props.storedetailimage],
                // doesn't have to be a valid url, only a stable ID with the form of an url
                '@id': `http://store.moncler.com/${storedetail.ID}`,
                name: storedetail.name,
                // TODO openingHoursSpecification
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: storedetail.address1,
                    addressLocality: storedetail.city,
                    addressRegion: storedetail.stateCode,
                    postalCode: storedetail.postalCode,
                    addressCountry: (_a = storedetail.countryCode) === null || _a === void 0 ? void 0 : _a.value,
                },
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: storedetail.latitude,
                    longitude: storedetail.longitude,
                },
                url: `${window.homeurl}/storelocator/${storedetail.slug}`,
                telephone: storedetail.phone,
            } }),
        React.createElement(StorePageSection, { title: t('store.title'), id: "intro", introSection: true },
            React.createElement(StoreBreadcrumb, { store: storedetail, hideStoreName: true }),
            React.createElement(StoreSummary, { store: storedetail }),
            React.createElement(StoreLocatorMap, Object.assign({}, props, { localMap: true, stores: [storedetail], currentStore: storedetail }))),
        React.createElement(StorePageSection, { title: t('store.boutiqueinformation'), id: "infos" },
            React.createElement(StorePageInnerSection, { title: t('store.address') },
                React.createElement(StoreAddress, { store: storedetail })),
            storedetail.storetype && (React.createElement(StorePageInnerSection, { title: t('store.type') },
                React.createElement("p", null, storedetail.storetype))),
            storedetail.storeHours && (React.createElement(StorePageInnerSection, { title: t('label.openinghours') }, storedetail.storeHours.map((sh) => (React.createElement("p", { key: sh.day },
                sh.day,
                React.createElement("br", null),
                sh.text)))))),
        (storedetail.phone || storedetail.email) && (React.createElement(StorePageSection, { title: t('store.contactinformation'), id: "contacts" },
            storedetail.phone && (React.createElement(StorePageInnerSection, { title: t('label.phone') },
                React.createElement("a", { href: `tel:${storedetail.phone}`, className: "contact-link" }, storedetail.phone),
                React.createElement("p", { className: "phone-note" },
                    "*",
                    t('storelocator.hasDOSService')))),
            storedetail.email && (React.createElement(StorePageInnerSection, { title: t('label.email') },
                React.createElement("a", { href: `mailto:${storedetail.email}`, className: "contact-link" }, storedetail.email))))),
        storedetail.hasInStoreServices && (React.createElement(StorePageSection, { title: t('store.storeservices'), id: "services" },
            React.createElement(StoreServices, { store: storedetail }))),
        storedetail.hasNearbyStores && (React.createElement(StorePageSection, { title: t('store.nearby'), id: "services" },
            React.createElement(StoresNearby, { stores: storedetail.nearbyStores })))));
};
export default StorePage;
